import * as Request from '../../request'

export const LOGIN_SUBMIT = 'LOGIN_SUBMIT'
export const LOGIN_SUBMIT_REQUEST = `${LOGIN_SUBMIT}_${Request.REQUEST}`
export const LOGIN_SUBMIT_SUCCESS = `${LOGIN_SUBMIT}_${Request.SUCCESS}`
export const LOGIN_SUBMIT_ERROR =  `${LOGIN_SUBMIT}_${Request.ERROR}`
export const UPDATE_LOGIN_FIELD = 'UPDATE_LOGIN_FIELD'
export const LOGIN_BASE_ROUTE = '/oauth/login'



// WEBPACK FOOTER //
// ./src/pages/login/constants.ts